import {
  appsInventoryApiListReceiptsGlobal,
  getAppsInventoryApiListReceiptsGlobalQueryKey,
} from '@/lib/api/generated/endpoints'
import type { AppsInventoryApiListReceiptsGlobalParams } from '@/lib/api/generated/types.ts/appsInventoryApiListReceiptsGlobalParams'
import type { StockReceiptOut } from '@/lib/api/generated/types.ts/stockReceiptOut'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

/**
 * Cross-project StockReceipt list — drives the global «Прибуткові накладні»
 * sidebar entry (ADR-0003 Iter 2 frontend).
 *
 * Backend: `GET /api/stock-receipts?project_id=&status=`. Per-project
 * scoping lives in `features/receipts` (project-scoped tab).
 */
export const stockReceiptsGlobalListQuery = (params?: AppsInventoryApiListReceiptsGlobalParams) =>
  typedSuspenseOptions<readonly StockReceiptOut[]>({
    queryKey: getAppsInventoryApiListReceiptsGlobalQueryKey(params),
    queryFn: ({ signal }) =>
      appsInventoryApiListReceiptsGlobal(params, { signal }) as unknown as Promise<
        readonly StockReceiptOut[]
      >,
    staleTime: 15_000,
  })
